export const CONFERENCE_INFO = {
    alwaysVisible: ['raised-hands-count', 'video-quality'],
    autoHide: [
        'highlight-moment',
        'subject',
        'conference-timer',
        'participants-count',
        'e2ee',
        'transcribing',
        'visitors-count',
        'insecure-room',
        'top-panel-toggle'
    ],
    detailIndicatorsLeft: ['visual-cues-status', 'acoustic-cues-status', 'recording-status', 'assistant-relation'],
    detailIndicatorsRight: ['transcript-link', 'transcript-link-edit']
};
